var _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _g5, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 162,
    fill: "none",
    viewBox: "0 0 500 162",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.622 40.31c-22.234 0-40.32 18.087-40.32 40.32 0 22.233 18.086 40.32 40.32 40.32 22.233 0 40.32-18.087 40.32-40.32 0-22.234-18.087-40.32-40.32-40.32zm-4.0425 72.312c-15.368-1.917-27.426-14.706-28.158-30.423l28.158 23.627v6.796zm0-17.32-27.182-22.791c0.8712-3.3455 2.3-6.4819 4.1121-9.3395l23.035 19.341v12.79h0.0348zm0-23.314-17.877-14.985c4.8091-4.4606 11.012-7.4925 17.877-8.3637v23.349zm8.0849-23.349c6.8652 0.8712 13.034 3.8682 17.878 8.3637l-17.878 14.985v-23.349zm0 33.873 23.07-19.341c1.847 2.8228 3.241 5.994 4.112 9.3395l-27.182 22.791v-12.79zm0 30.11v-6.796l28.158-23.627c-0.732 15.682-12.789 28.471-28.158 30.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.83 113.25c0.662 0.383 1.359 0.592 2.091 0.592 1.359 0 2.683-0.697 3.45-1.951 5.68-9.41 8.712-20.213 8.712-31.26 0-33.35-27.113-60.463-60.463-60.463-11.047 0-21.85 2.997-31.259 8.7122-1.9167 1.15-2.5091 3.6243-1.3591 5.5409 1.15 1.9167 3.6243 2.5092 5.5409 1.3591 8.1546-4.9485 17.529-7.5273 27.112-7.5273 28.89 0 52.413 23.523 52.413 52.413 0 9.5834-2.614 18.958-7.563 27.113-1.185 1.846-0.557 4.321 1.325 5.471z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.156 45.642c-1.8469-1.2546-4.3561-0.7667-5.6106 1.0803-6.7955 10.036-10.385 21.746-10.385 33.908 0 33.35 27.112 60.463 60.463 60.463 12.162 0 23.872-3.59 33.908-10.385 1.847-1.255 2.335-3.764 1.08-5.611-1.254-1.847-3.763-2.335-5.61-1.08-8.678 5.889-18.853 8.991-29.378 8.991-28.89 0-52.413-23.488-52.413-52.413 0-10.524 3.1016-20.7 8.991-29.378 1.2894-1.8122 0.8015-4.3213-1.0455-5.5758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.962 128.83c1.8122-1.324 2.1955-3.833 0.9061-5.646-21.049-28.994-17.912-68.477 7.4576-93.847 25.37-25.37 64.854-28.541 93.848-7.4577 1.812 1.3243 4.321 0.9061 5.645-0.906 1.325-1.8122 0.907-4.3213-0.906-5.6455-15.368-11.152-34.291-16.518-53.318-15.09-19.237 1.4288-37.323 9.7228-50.984 23.384-13.661 13.661-21.955 31.747-23.384 50.984-1.4288 19.027 3.9379 37.951 15.09 53.319 0.8015 1.08 2.0212 1.673 3.2758 1.673 0.8364 0 1.6727-0.244 2.3697-0.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.93 33.342c-1.324-1.8122-3.833-2.1955-5.646-0.9061-1.812 1.3243-2.195 3.8334-0.906 5.6455 21.049 28.994 17.913 68.478-7.457 93.848s-64.854 28.541-93.848 7.458c-1.8121-1.325-4.3213-0.906-5.6455 0.906-1.3243 1.812-0.9061 4.321 0.9061 5.645 13.73 9.967 30.353 15.334 47.325 15.334 1.9864 0 4.0076-0.07 5.994-0.209 19.237-1.429 37.323-9.723 50.984-23.384s21.955-31.747 23.383-50.984c1.394-19.062-3.972-38.02-15.089-53.353z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1703_9402",
    x: 275,
    y: 41,
    width: 62,
    height: 55,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m336.68 95.668-25.36-51.66c-0.732-1.5421-2.389-2.54-4.218-2.5536h-2.195c-1.825 0.0151-3.486 1.013-4.215 2.5536l-25.355 51.66h11.789l4.962-10.462h27.772l5.027 10.462h11.793zm-40.575-18.959 9.772-20.622 9.904 20.622h-19.676z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask0_1703_9402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1703_9402",
    x: 10,
    y: 4,
    width: 480,
    height: 158,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.205 4.2451h479.32v157.23h-479.32v-157.23z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask1_1703_9402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m260.45 26.332h91.116v84.454h-91.116v-84.454z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1703_9402",
    x: 451,
    y: 42,
    width: 49,
    height: 54,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m489.33 42.737-0.048 38.434c5e-3 1.0472-0.413 2.0536-1.162 2.7975s-1.767 1.1644-2.831 1.1689h-18.581c-1.065-0.0016-2.087-0.4209-2.838-1.1652s-1.17-1.7523-1.164-2.8012l-0.047-38.434h-10.669v39.727c0 7.3025 5.983 13.235 13.334 13.235h21.339c7.35 0 13.335-5.9327 13.335-13.235v-39.727h-10.668z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask2_1703_9402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1703_9402",
    x: -4,
    y: 2,
    width: 505,
    height: 161,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m-3.0151 2.7346h503.02v159.89h-503.02v-159.89z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask3_1703_9402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.37 27.355h79.253v83.717h-79.253v-83.717z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1703_9402",
    x: 362,
    y: 42,
    width: 66,
    height: 54,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m393 85.199h3.625c1.833 0 3.189-1.0454 4.221-2.5213l15.463-22.845v35.867h10.744l-0.016-47.674c0-2.921-2.406-5.2885-5.373-5.2885h-4.058c-1.386 0-2.686 0.801-3.411 1.8448l-19.383 28.057-19.392-28.057c-0.729-1.0454-2.021-1.8448-3.406-1.8448h-4.062c-2.969 0.0051-5.372 2.3721-5.369 5.2885l-0.019 47.674h10.744v-35.867l15.46 22.845c1.035 1.4759 2.391 2.5213 4.232 2.5213",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask4_1703_9402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1703_9402",
    x: -2,
    y: 2,
    width: 505,
    height: 161,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m-1.3994 2.7346h503.87v159.89h-503.87v-159.89z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask5_1703_9402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.92 27.355h95.782v83.717h-95.782v-83.717z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1703_9402",
    x: 200,
    y: 42,
    width: 54,
    height: 54,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m242.57 79.818-29.506-35.236c-0.864-1.0454-1.977-1.8448-3.338-1.8448h-3.973c-2.912 0.0085-5.267 2.376-5.259 5.2885l-0.018 47.674h10.523v-37.081l29.502 35.221c0.864 1.0608 1.983 1.8602 3.344 1.8602h3.972c2.9 0 5.26-2.3675 5.26-5.287l0.015-47.675h-10.522v37.081z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1703_9402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1703_9402",
    x: 0,
    y: 2,
    width: 496,
    height: 161,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m0.74316 2.7346h495.03v159.89h-495.03v-159.89z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#mask7_1703_9402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.1 27.355h83.365v83.717h-83.365v-83.717z",
    fill: "#fff"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m305.94 132.58c1.38 0.388 2.443 1.097 3.19 2.125 0.769 1.028 1.153 2.285 1.153 3.771 0 2.057-0.735 3.668-2.205 4.833-1.448 1.166-3.45 1.748-6.006 1.748h-10.857v-24.167h10.518c2.488 0 4.433 0.56 5.836 1.68 1.425 1.097 2.137 2.64 2.137 4.628 0 1.28-0.339 2.388-1.018 3.325-0.656 0.937-1.572 1.622-2.748 2.057zm-10.45-1.509h5.531c3.008 0 4.512-1.131 4.512-3.393 0-1.143-0.373-1.989-1.12-2.537-0.746-0.548-1.877-0.823-3.392-0.823h-5.531v6.753zm6.107 10.559c1.584 0 2.737-0.286 3.461-0.857 0.724-0.572 1.086-1.463 1.086-2.674 0-1.212-0.373-2.114-1.12-2.708-0.724-0.595-1.866-0.892-3.427-0.892h-6.107v7.131h6.107z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m330.55 145.37c-3.28 0-5.768-0.857-7.465-2.571-1.696-1.714-2.544-4.216-2.544-7.507v-14.398h4.275v14.638c0 2.079 0.486 3.656 1.459 4.73 0.972 1.052 2.397 1.577 4.275 1.577 1.854 0 3.268-0.537 4.241-1.611 0.972-1.074 1.459-2.639 1.459-4.696v-14.638h4.274v14.398c0 3.268-0.848 5.77-2.544 7.507-1.697 1.714-4.173 2.571-7.43 2.571z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m359.97 145.37c-1.832 0-3.551-0.251-5.157-0.754s-2.963-1.211-4.071-2.125l1.459-3.223c1.153 0.891 2.363 1.543 3.63 1.954 1.289 0.412 2.68 0.617 4.173 0.617 1.651 0 2.918-0.285 3.8-0.857 0.905-0.594 1.357-1.417 1.357-2.468 0-0.914-0.418-1.611-1.255-2.091-0.814-0.48-2.183-0.937-4.105-1.371-1.991-0.434-3.608-0.937-4.852-1.508-1.244-0.572-2.183-1.303-2.816-2.194-0.634-0.892-0.95-2.023-0.95-3.394 0-1.417 0.384-2.685 1.153-3.805s1.855-1.988 3.257-2.605c1.403-0.64 3.02-0.96 4.852-0.96 1.674 0 3.269 0.263 4.784 0.788 1.516 0.503 2.76 1.2 3.732 2.091l-1.459 3.223c-2.126-1.714-4.478-2.571-7.057-2.571-1.538 0-2.759 0.32-3.664 0.959-0.882 0.617-1.323 1.486-1.323 2.606 0 0.937 0.396 1.657 1.187 2.159 0.792 0.503 2.138 0.972 4.038 1.406 2.013 0.457 3.641 0.971 4.885 1.542 1.267 0.549 2.228 1.257 2.884 2.126 0.679 0.868 1.018 1.965 1.018 3.291 0 1.439-0.384 2.708-1.153 3.805-0.747 1.074-1.844 1.908-3.291 2.502-1.425 0.571-3.111 0.857-5.056 0.857z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m379.8 120.89h4.377v24.167h-4.377v-24.167z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m415.83 120.89v24.167h-3.291l-12.825-16.865v16.865h-4.071v-24.167h3.257l12.825 16.832v-16.832h4.105z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m427.29 120.89h16.015v3.497h-11.74v6.65h11.061v3.462h-11.061v7.062h11.74v3.496h-16.015v-24.167z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m461.34 145.37c-1.832 0-3.551-0.251-5.157-0.754s-2.963-1.211-4.071-2.125l1.459-3.223c1.153 0.891 2.363 1.543 3.63 1.954 1.289 0.412 2.68 0.617 4.173 0.617 1.651 0 2.918-0.285 3.8-0.857 0.905-0.594 1.357-1.417 1.357-2.468 0-0.914-0.418-1.611-1.255-2.091-0.814-0.48-2.183-0.937-4.105-1.371-1.991-0.434-3.608-0.937-4.852-1.508-1.244-0.572-2.183-1.303-2.816-2.194-0.634-0.892-0.95-2.023-0.95-3.394 0-1.417 0.384-2.685 1.153-3.805s1.855-1.988 3.257-2.605c1.403-0.64 3.02-0.96 4.852-0.96 1.674 0 3.269 0.263 4.784 0.788 1.516 0.503 2.76 1.2 3.732 2.091l-1.459 3.223c-2.126-1.714-4.478-2.571-7.057-2.571-1.538 0-2.759 0.32-3.664 0.959-0.882 0.617-1.323 1.486-1.323 2.606 0 0.937 0.396 1.657 1.187 2.159 0.792 0.503 2.138 0.972 4.038 1.406 2.013 0.457 3.641 0.971 4.885 1.542 1.267 0.549 2.228 1.257 2.884 2.126 0.679 0.868 1.018 1.965 1.018 3.291 0 1.439-0.384 2.708-1.153 3.805-0.747 1.074-1.844 1.908-3.291 2.502-1.425 0.571-3.111 0.857-5.056 0.857z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m489.28 145.37c-1.832 0-3.551-0.251-5.157-0.754s-2.963-1.211-4.071-2.125l1.459-3.223c1.153 0.891 2.363 1.543 3.63 1.954 1.289 0.412 2.68 0.617 4.173 0.617 1.651 0 2.918-0.285 3.8-0.857 0.905-0.594 1.357-1.417 1.357-2.468 0-0.914-0.418-1.611-1.255-2.091-0.814-0.48-2.183-0.937-4.106-1.371-1.99-0.434-3.607-0.937-4.851-1.508-1.244-0.572-2.183-1.303-2.816-2.194-0.634-0.892-0.95-2.023-0.95-3.394 0-1.417 0.384-2.685 1.153-3.805s1.855-1.988 3.257-2.605c1.403-0.64 3.02-0.96 4.852-0.96 1.674 0 3.269 0.263 4.784 0.788 1.515 0.503 2.76 1.2 3.732 2.091l-1.459 3.223c-2.126-1.714-4.478-2.571-7.057-2.571-1.538 0-2.759 0.32-3.664 0.959-0.882 0.617-1.323 1.486-1.323 2.606 0 0.937 0.396 1.657 1.187 2.159 0.792 0.503 2.138 0.972 4.038 1.406 2.013 0.457 3.641 0.971 4.885 1.542 1.267 0.549 2.228 1.257 2.884 2.126 0.679 0.868 1.018 1.965 1.018 3.291 0 1.439-0.384 2.708-1.153 3.805-0.747 1.074-1.844 1.908-3.292 2.502-1.425 0.571-3.11 0.857-5.055 0.857z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullWhite);
export default __webpack_public_path__ + "static/media/logo_full_white.0fa93eb5909520e1417ce3830faf3084.svg";
export { ForwardRef as ReactComponent };